export { CTAPrimary, type PatternCTAMobileProps } from "./cta-primary";
export { CTAPrimary as default } from "./cta-primary";
